<script>
    export default {
        name: "TheCheckoutStepOne",
        props: {
            routerStep: Number,
        },
        created() {
            this.$emit("child-init", this.routerStep);
        },
    };
</script>

<template>
    <div class="o-step-one"></div>
</template>
